// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = ({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    zIndex: 10,
  },
  mainPaper: {
    width: 800,
    padding: 10,
    margin: '30px 15px',
    borderRadius: 20,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    display: 'flex',
    justifyContent: 'center',
    zIndex: 10,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '93%',
  },
  topTextContainer: {
    margin: 10,
    paddingTop: 20,
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  topText: {
    borderBottomWidth: 2,
    borderBottomColor: GlobalStyles.color.COLOR_BLUE,
    borderBottomStyle: 'solid',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
  }
});

export default styles;
